export const INCIDENT_TYPES = [
  { value: "vehicle_accident", label: "Vehicle accident" },
  { value: "injury_illness", label: "Injury / illness" },
  { value: "near_miss", label: "Near miss" },
  { value: "property_damage", label: "Property damage" },
  { value: "equipment_failure_damage", label: "Equipment failure / damage" },
  { value: "environmental_spill_leak", label: "Environmental spill / leak" },
  { value: "unsafe_behaviour_condition", label: "Psychosocial hazard" },
  { value: "other", label: "Other" },
];

export const LOCATION_TYPES = [
  { value: "greenspace_workplace_depot", label: "Greenspace workplace / depot" },
  { value: "customer_job_site", label: "Customer / job site" },
  { value: "public_road", label: "Public road" },
  { value: "other", label: "Other" },
];

export const IMMEDIATE_ACTIONS = [
  ["area_made_safe", "Area made safe"],
  ["first_aid_provided", "First aid provided"],
  ["manager_notified", "Manager notified"],
  ["customer_notified", "Customer notified"],
  ["emergency_services_notified", "Police / emergency services notified"],
  ["vehicle_equipment_out_of_service", "Vehicle/equipment taken out of service"],
  ["spill_contained", "Spill contained"],
  ["no_immediate_action_required", "No immediate action required"],
  ["other", "Other"],
];

export const INCIDENT_STEPS = [
  "Reporter and incident",
  "Incident type",
  "Description",
  "Immediate actions",
  "Witnesses and evidence",
  "Review and submit",
];

export const STATUS_LABELS = {
  draft_part_a: "Draft",
  injury_handoff: "Injury - manager action required",
  submitted: "Submitted",
  under_manager_review: "Under manager review",
  corrective_actions_open: "Corrective actions open",
  closed: "Closed",
};

export function isInjuryHandoff(section2 = {}) {
  return (
    section2.incidentType === "injury_illness" &&
    section2.typeDetails?.injury?.someoneInjuredOrAffected === true
  );
}

export function incidentTypeLabel(value) {
  return INCIDENT_TYPES.find((item) => item.value === value)?.label || "Not selected";
}
